export default "__VITE_ASSET__9OU76xiz__"